"use client";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

// Transition de page
export default function PageTransition() {
	const pathname = usePathname();
	const [nextTitle, setNextTitle] = useState("");
	const [showTitle, setShowTitle] = useState(false);

	// Lorsqu'une transition démarre (classe "page-exit"), on lit le href stocké et on génère un titre à afficher.
	// Si c'est une page projet (/work/[slug]), on formate dynamiquement le slug en titre lisible.
	useEffect(() => {
		if (!showTitle) return;

		const nextHref = sessionStorage.getItem("nextHref");

		if (nextHref) {
			const parts = nextHref.split("/");
			if (parts[2] === "work" && parts[3]) {
				setNextTitle(parts[3].replace(/-/g, " "));
			} else {
				const titles = {
				  fr: {
				    "/": "Accueil",
				    "/about": "À propos",
				    "/work": "Projets",
				    "/contact": "Contact",
				    "/services": "Services",
				    "/legal": "Mentions légales",
				  },
				  en: {
				    "/": "Home",
				    "/about": "About",
				    "/work": "Work",
				    "/contact": "Contact",
				    "/services": "Services",
				    "/legal": "Legal notice",
				  },
				};

				const lang = parts[1];
				const route = "/" + parts.slice(2).join("/");

				setNextTitle(titles[lang]?.[route] || "");
			}
		}
	}, [showTitle]);

	// Observe les changements de classes sur <body> pour détecter la présence de "page-enter" ou "page-exit".
	useEffect(() => {
		const observer = new MutationObserver(() => {
			const hasExit = document.body.classList.contains("page-exit");
			const hasEnter = document.body.classList.contains("page-enter");

			setShowTitle(hasExit || hasEnter);

			// Désactive les clics pendant les transitions
			if (hasExit || hasEnter) {
				document.body.style.pointerEvents = "none";
			} else {
				document.body.style.pointerEvents = "";
			}
		});

		observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
		return () => observer.disconnect();
	}, []);

	// Quand la route change (nouvelle page chargée), on applique la classe "page-enter" et on nettoie les classes + le stockage.
	useEffect(() => {
		document.body.classList.remove("page-exit");
		document.body.classList.add("page-enter");

		const timeout = setTimeout(() => {
			window.scrollTo({ top: 0, left: 0, behavior: "auto" });
			document.body.classList.remove("page-enter");
			sessionStorage.removeItem("nextHref");
		}, 900); // durée de l'anim d'entrée

		return () => clearTimeout(timeout);
	}, [pathname]);

	// Affiche le titre centré à l'écran uniquement pendant la transition "page-exit".
	return (
		<>
			{showTitle && nextTitle && (
				<div className="page-transition-title">
					<div className="page-title-wrapper">
						{[...nextTitle].map((char, i) => {
							const isFirst = i === 0 || (nextTitle[i - 1] === " " && char !== " ");
							return (
								<span key={i} style={{ animationDelay: `${0.75 + i * 0.02}s` }}>
									{char === " " ? "\u00A0" : char}
								</span>
							);
						})}
					</div>
				</div>
			)}
		</>
	);
}
